import baseControllerInput from './baseControllerInput'
import { createAutoCorrectedDatePipe } from 'text-mask-addons'
import getErrorToDOB from './validations/getErrorToDOB'
import { DATE_REGEX } from 'core/constants/regex'

export default baseControllerInput({
  getErrorMessage: (state, sdate) => {
    return getErrorToDOB(state.typeMember, state.input.value, sdate)
  },
  maskConfig: {
    mask: DATE_REGEX,
    pipe: createAutoCorrectedDatePipe('mm/dd/yyyy'),
    keepCharPositions: true
  }
})
